import React from 'react';
import PropTypes from 'prop-types';

const BulletPoints = ({ totalSteps, currentStep, handleOnClick }) =>
  Array(totalSteps)
    .fill(null)
    .map((_, i) => (
      <span
        className={`value-proposition-modal__bullet ${
          currentStep === i + 1 ? 'value-proposition-modal__bullet--active' : ''
        }`}
        role="button"
        tabIndex={0}
        onClick={() => handleOnClick(i)}
      />
    ));

BulletPoints.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  handleOnClick: PropTypes.func
};

BulletPoints.defaultProps = {
  handleOnClick: () => {}
};

export default BulletPoints;
